import React, { HTMLAttributes } from 'react';
import * as styles from '../../styles/nvIcons.module.scss';

const GroupIcon: React.FC<HTMLAttributes<HTMLElement>> = (props) => (
  <i
    {...props}
    className={`${props.className} ${styles.nv_icon_ring_group}`}
  ></i>
);

export default GroupIcon;
